import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { WorkbenchService } from '@affine/core/modules/workbench';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { DEMO_TOUR_SESSION_ID } from '../constants';
import { TutorialPersistence } from '../services/tutorial-persistence';
import { TutorialRegistry } from '../services/tutorial-registry';

/** Shared entry for the first-start dialog and Settings. No document preload. */
export function useStartWelcomeTour() {
  const dialogs = useService(WorkspaceDialogService);
  const persistence = useService(TutorialPersistence);
  const registry = useService(TutorialRegistry);
  const workbench = useService(WorkbenchService).workbench;
  const workspace = useService(WorkspaceService).workspace;

  return useCallback(() => {
    persistence.markCompleted(`onboarding-welcome:${workspace.meta.id}`);
    persistence.reset(DEMO_TOUR_SESSION_ID);
    dialogs.closeAll();
    workbench.openAll();
    registry.start(DEMO_TOUR_SESSION_ID);
  }, [dialogs, persistence, registry, workbench, workspace]);
}
